import {useEffect, useId, useState} from "react";
import {Camera, Package, Smartphone} from "lucide-react";
import {api, pesanGalat} from "../../../lib/api";

const ROOT = "/inventory/workspace/photos";
const path = (kind, id) => `${ROOT}/${kind}/${encodeURIComponent(id)}`;

export function ProductPhoto({photo, name, accessory = false}) {
  const [src, setSrc] = useState("");
  const kind = photo?.kind, id = photo?.id, revision = photo?.revision;
  useEffect(() => {
    setSrc("");
    if (!kind || !id) return;
    let active = true, url;
    const controller = new AbortController();
    api.get(path(kind,id), {responseType:"blob", signal:controller.signal}).then(({data}) => {
      if (active) {url = URL.createObjectURL(data); setSrc(url);}
    }).catch(() => {});
    return () => {active = false; controller.abort(); if (url) URL.revokeObjectURL(url);};
  }, [kind,id,revision]);
  return src ? <img className="eh-product-photo" src={src} alt={`Foto ${name}`} onError={() => setSrc("")}/>
    : <div className={`eh-art ${accessory ? "accessory" : ""}`}>{accessory ? <Package/> : <Smartphone/>}</div>;
}

export function PhotoEditor({kind, id, photo, name, editable, onSaved}) {
  const inputId = useId(), [busy,setBusy] = useState(false), [error,setError] = useState("");
  const own = photo && (kind === "product" || photo.source !== "product");
  const save = async file => {
    if (!file || busy) return;
    if (file.size > 5*1024*1024) {setError("Ukuran foto maksimal 5 MB"); return;}
    setBusy(true); setError("");
    try {const body = new FormData(); body.append("file",file); const {data} = await api.put(path(kind,id),body); onSaved(data.photo);}
    catch(e) {setError(pesanGalat(e));} finally {setBusy(false);}
  };
  const remove = async () => {
    setBusy(true); setError("");
    try {const {data} = await api.delete(path(kind,id)); onSaved(data.photo);}
    catch(e) {setError(pesanGalat(e));} finally {setBusy(false);}
  };
  return <section className="eh-photo-editor" data-testid="inventory-photo-editor">
    <ProductPhoto photo={photo} name={name}/><div><h3>Foto {kind === "product" ? "katalog" : kind === "unit" ? "unit" : "batch"}</h3>
      <p>{kind === "product" ? "Dipakai oleh barang dengan SKU ini yang belum punya foto khusus." : photo?.source === "product" ? "Memakai foto katalog. Pilih foto untuk menggantinya khusus barang ini." : "Foto khusus barang ini, misalnya kondisi fisik atau kelengkapan."}</p>
      {editable && <><div className="eh-actions"><label className={`eh-btn secondary ${busy ? "eh-photo-busy" : ""}`} htmlFor={inputId}><Camera size={16}/>{busy ? "Menyimpan…" : "Pilih / ambil foto"}</label><input id={inputId} aria-label="Unggah foto produk" type="file" accept="image/jpeg,image/png,image/webp" disabled={busy} className="eh-photo-input" onChange={e => {save(e.target.files?.[0]);e.target.value="";}}/>
        {own && <button type="button" className="eh-link" disabled={busy} onClick={remove}>Hapus foto{kind !== "product" ? " khusus" : ""}</button>}</div>
        <small>JPG, PNG, WebP · maksimal 5 MB / 20 MP. Foto langsung tersimpan setelah dipilih.</small></>}
      {error && <p role="alert" className="eh-photo-error">{error}</p>}
    </div>
  </section>;
}
